import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { Subject, debounceTime } from 'rxjs';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { AbandonoPedimentoService } from 'src/app/_services/abandonoPedimento/abandono-pedimento.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { CatalogsService } from 'src/app/_services/catalogs/catalogs.service';
import { AuthorizationsService } from 'src/app/_services/authorizations/authorizations.service';
import { BillingService } from 'src/app/_services/billing/billing.service';
import { SlabService } from 'src/app/_services/slab/slab.service';

/**
 * Componente de barra de navegación superior que gestiona el campo de búsqueda
 * global, conservando el historial de búsquedas y filtrando, según la ruta
 * activa, los distintos listados de la aplicación (lotes, entradas, salidas,
 * pedimentos, abandonos, boletas, catálogos, usuarios y facturas).
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  lastFilter: string = '';
  blackListListaBl: string[] = ['id_operation', 'abandonment_status', 'days_abandonment'];
  blackListListaLotes: string[] = [ 'registry_number', 'id_master', 'customer_id', 'business_name_client', 'docking_date', 'material_group_id', 'material_id', 'material_name', 'packing_id', 'packaging', 'observations', 'quantity_pieces', 'origin', 'location_id', 'days_free_storage', 'storage_fee', 'special_storage_rate', 'consignee_name', 'address_consignee', 'commercial_value', 'bill_lading', 'shipper_receiver', 'address_shipper_receiver', 'damage_violation_record', 'identification_stored_merchandise', 'volume_occupied_merchandise', 'merchandise_fiscalized_area' ];
  blackListListaLotesAsignados: string[] =  [ "registry_number", "customer_lot_number", "customer_id", "id_business_name", "docking_date", "undocking_date", "material_group_id", "material_id", "packing_id", "observations", "tonnage", "location_id", "days_free_storage", "storage_fee", "special_storage_rate", "consignee_name", "address_consignee", "commercial_value", "shipper_receiver", "address_shipper_receiver", "damage_violation_record", "identification_stored_merchandise", "volume_occupied_merchandise", "merchandise_fiscalized_area", "pama_number", "fiscal_folio_cfdi", "total_amount_cfdi", "total_amount_presentation", "amount_merchandise_deposit", "compensation_amount", "address", "container_dimension", "container_type", "number_container_seals", "number_container_locks", "unconsolidated_container", "deconsolidated_store", "unconsolidated_means_transport", "consolidated_container", "consolidated_store", "consolidated_means_transport", "origin", "material_name", "packaging" ];
  blackListListaLotesAsignadosExportCabotage: string[] =  [ "id_export_batch", "id_export_outputs", "customer_id", "id_business_name", "material_group_id", "material_id", "packing_id", "observations", "location_id", "days_free_storage", "storage_fee", "special_storage_rate", "consignee_name", "address_consignee", "commercial_value", "shipper_receiver", "address_shipper_receiver", "damage_violation_record", "identification_stored_merchandise", "volume_occupied_merchandise", "merchandise_fiscalized_area", "pama_number", "fiscal_folio_cfdi", "total_amount_cfdi", "total_amount_presentation", "amount_merchandise_deposit", "compensation_amount", "address", "container_dimension", "container_type", "number_container_seals", "number_container_locks", "unconsolidated_container", "deconsolidated_store", "unconsolidated_means_transport", "consolidated_container", "consolidated_store", "consolidated_means_transport", "origin", "material_group_name", "packaging", "location_name", "input_tons", "remaining_tons"];
  blackListExportBatches: string[] = [ "bl_lot_id", "customer_id", "id_business_name", "material_group_id", "material_id", "packing_id", "observations", "tonnage", "quantity_pieces", "location_id", "days_free_storage", "storage_fee", "special_storage_rate", "consignee_name", "address_consignee", "commercial_value", "shipper_receiver", "address_shipper_receiver", "damage_violation_record", "identification_stored_merchandise", "volume_occupied_merchandise", "merchandise_fiscalized_area", "pama_number", "fiscal_folio_cfdi", "total_amount_cfdi", "total_amount_presentation", "amount_merchandise_deposit", "compensation_amount", "container_dimension", "container_type", "number_container_seals", "number_container_locks", "unconsolidated_container", "deconsolidated_store", "unconsolidated_means_transport", "consolidated_container", "consolidated_store", "consolidated_means_transport", "origin", "material_group_name", "packaging", "location_name", "output_tons" ];
  blackListCabotageBatches: string[] = [ "customer_id", "id_business_name", "bl_lot_id", "material_group_id", "material_id", "packing_id", "observations", "tonnage", "quantity_pieces", "origin", "destination", "commercial_value", "days_free_storage", "storage_fee", "special_storage_rate", "shipper_receiver", "address_shipper_receiver", "damage_violation_record", "identification_stored_merchandise", "volume_occupied_merchandise", "merchandise_fiscalized_area", "consignee_name", "address_consignee", "container_dimension", "container_type", "number_container_seals", "number_container_locks", "unconsolidated_container", "deconsolidated_store", "unconsolidated_means_transport", "consolidated_container", "consolidated_store", "consolidated_means_transport", "pama_number", "fiscal_folio_cfdi", "total_amount_cfdi", "total_amount_presentation", "amount_merchandise_deposit", "compensation_amount", "customs_agent", "material_group_name", "packaging", "output_tons" ];
  blackListImportEntries: string[] = [ "input_type_id", "batch_status_id" ];
  blackListExportEntries: string[] = [ "export_batch_id", "origin_weight", "gross_weight", "tare_weight", "net_weight", "van_plate", "precinct_key", "tractor_plates", "total_pieces", "customs_agent", "appointments", "location_id", "observations", "transfered_by", "output_id", "entry_type_id", "batch_status" ];
  blackListCabotageEntries: string[] = [ "cabotage_batch_id", "precinct_key", "tractor_plates", "origin_weight", "gross_weight", "tare_weight", "net_weight", "number_pieces", "van_plate", "total_pieces", "location_id", "observations", "transfered_by", "output_id", "cabotage_batch_transfered", "entry_type_id", "batch_status" ];
  blackListImportOutputs: string[] = [ "output_type_option_id", "batch_id", "precinct_key", "key_request", "id_master", "transport_type_id", "trailer_id", "origin_weight", "gross_weight", "tare_weight", "net_weight", "origin_weight2", "gross_weight2", "tare_weight2", "net_weight2", "total_pieces", "van_plate", "van_plate2", "folio_ticket_number", "folio_ticket_number2", "operator_name", "transport_line", "remittance", "parts_ii", "umc", "ump", "integration_number", "customs_agent", "pre_registration_samples", "release_number", "company_transfers", "transfer_date", "key_destination_enclosure", "returning_destiny", "returning_company", "domicile_returning_company", "observations", "transfer_folio", "autorization_losses_document", "destiny", "company_destiny", "modulation_status" ];
  blackListExportOutputs: string[] = [ "output_type_option_id", "export_batch_id", "precinct_key", "total_pieces", "addressee", "destination_company", "request_number", "customs_agent", "withdrawal_number", "losses_autorization", "observations", "export_batch_to_transfer", "person_to_transfer", "consignee_name", "address_consignee", "batch_status" ];
  blackListCabotageOutputs: string[] = [ "output_type_option_id", "cabotage_batch_id", "precinct_key", "addressee", "destination_company", "customs_agent", "withdrawal_number", "total_pieces", "losses_autorization", "observations", "cabotage_batch_to_transfer", "person_to_transfer", "consignee_name", "address_consignee", "batch_status" ];
  blackListPedimentos: string[] = [ "id", "customs_entry_key", "name_customs_entry_document", "user_create_id", "user_update_id", "batch_id", "modulation_status", "custom_entry_tons_released", "registry_number", "modulation_status_description" ];
  blackListAbandonos: string[] = [ "batch_id" ];
  blackListScaleTicket: string[] = [ "trucks_id", "trailer_plates1", "trailer_plates2", "van_number", "operator_name", "origin_weight", "entry_date", "input_weight", "departure_date", "output_weight", "operation_type", "lot_number", "material_group_id", "material_id", "ship_number", "ship_name", "transport_type_id", "trailer_id", "customer_trailer", "appointment_number", "status" ];
  blackListSlabs: string [] = ['id', 'item', 'heat_number', 'thickness', 'nominal_length', 'bl', 'ship_number', 'ship_name', 'status'];
  debouncer: Subject<string> = new Subject();
  searchOptions: string[] = [];

  constructor(
    private blServices: BlService,
    private billingSvc: BillingService,
    private loteService: LoteService,
    private loteCabotajeService: LoteCabotajeService,
    private pedimentoAbandonoService: AbandonoPedimentoService,
    private localStorageServices: LocalStorageService,
    private scaleTicketSvc: ScaleTicketService,
    private catalogService: CatalogsService,
    private authorizationsSvc: AuthorizationsService,
    private slabSvc: SlabService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.updateSearchOptions();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.addOptions();
        this.blTextFilter = '';
        this.lastFilter = '';
      }
    });

    this.debouncer
    .pipe(
      debounceTime(500)
    ).subscribe( value => this.filter())
  }

  get blTextFilter() {
    return this.blServices.textFilter;
  }

  set blTextFilter(value: string) {
    this.blServices.textFilter = value;
  }

  /**
   * Agrega el filtro actual al historial de búsquedas (máximo cuatro) y lo persiste en almacenamiento local.
   */
  addOptions() {
    if (this.blTextFilter && !this.searchOptions.includes(this.blTextFilter)) {
      this.searchOptions.unshift(this.blTextFilter);
      this.searchOptions = [...this.searchOptions.slice(0, 4)];
      this.localStorageServices.setData('searchOptions', this.searchOptions);
    }
  }

  /**
   * Refresca las opciones de búsqueda al activarse el campo.
   */
  isActive() {
    this.updateSearchOptions();
  }

  /**
   * Emite el texto de búsqueda al debouncer para disparar el filtrado.
   */
  keyPress() {
    this.debouncer.next( this.blTextFilter );
  }

  /**
   * Carga el historial de búsquedas desde el almacenamiento local o lo inicializa vacío.
   */
  updateSearchOptions() {
    const storageOptions = this.localStorageServices.getData('searchOptions');
    if (storageOptions) {
      this.searchOptions = storageOptions;
    } else {
      this.localStorageServices.saveData('searchOptions', []);
      this.searchOptions = [];
    }
  }

  /**
   * Filtra el listado correspondiente a la ruta actual usando el texto de búsqueda, respetando las listas negras de campos por vista.
   */
  filter() {
    const currentURL: string = this.router.url;
    if (this.lastFilter === this.blTextFilter) {
      this.lastFilter = this.blTextFilter;
      return;
    }
    this.lastFilter = this.blTextFilter;

    if (currentURL.includes('lote-lista')) {
      if (this.blTextFilter === '') {
        this.loteService.lotesFilter = [...this.loteService.lotes];
        return;
      }
      this.loteService.lotesFilter = this.loteService.lotes.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListListaLotes.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        })
        return match;
      });
      return;
    }

    // Lotes de exportacion
    if (currentURL.includes('/exportation/batch-list')) {
      if (this.blTextFilter === '') {
        this.loteService.lotesExportacionFilter = [...this.loteService.lotesExportacion];
        return;
      }
      this.loteService.lotesExportacionFilter = this.loteService.lotesExportacion.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListExportBatches.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de lotes de cabotaje
    if (currentURL.includes('/cabotage/batch-list')) {
      if (this.blTextFilter === '') {
        this.loteCabotajeService.lotesCabotajeFilter = [...this.loteCabotajeService.lotesCabotaje];
        return;
      }
      this.loteCabotajeService.lotesCabotajeFilter = this.loteCabotajeService.lotesCabotaje.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListCabotageBatches.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de entradas de importacion
    if (currentURL.includes('/importation/batch-movement/entry-list/')) {
      if (this.blTextFilter === '') {
        this.loteService.importEntriesFilter = [...this.loteService.importEntries];
        return;
      }
      this.loteService.importEntriesFilter = this.loteService.importEntries.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListImportEntries.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de entradas de exportacion
    if (currentURL.includes('/exportation/batch-movement/entry-list/')) {
      if (this.blTextFilter === '') {
        this.loteService.exportEntriesFilter = [...this.loteService.exportEntries];
        return;
      }
      this.loteService.exportEntriesFilter = this.loteService.exportEntries.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListExportEntries.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de entradas de cabotaje
    if (currentURL.includes('/cabotage/batch-movement/entry-list/')) {
      if (this.blTextFilter === '') {
        this.loteCabotajeService.cabotageEntriesFilter = [...this.loteCabotajeService.cabotageEntries];
        return;
      }
      this.loteCabotajeService.cabotageEntriesFilter = this.loteCabotajeService.cabotageEntries.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListCabotageEntries.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de salidas de iportacion
    if (currentURL.includes('/importation/batch-movement/output-list/')) {
      if (this.blTextFilter === '') {
        this.loteService.importOutputsFilter = [...this.loteService.importOutputs];
        return;
      }
      this.loteService.importOutputsFilter = this.loteService.importOutputs.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListImportOutputs.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de planchones de importacion
    if (currentURL.includes('/importation/batch-movement/slab-list/')) {
      this.slabSvc.filterSlabsByStatus();
    }

    // Lista de salidas de exportacion
    if (currentURL.includes('/exportation/batch-movement/output-list/')) {
      if (this.blTextFilter === '') {
        this.loteService.exportOutputsFilter = [...this.loteService.exportOutputs];
        return;
      }
      this.loteService.exportOutputsFilter = this.loteService.exportOutputs.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListExportOutputs.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de salidas de cabotaje
    if (currentURL.includes('/cabotage/batch-movement/output-list/')) {
      if (this.blTextFilter === '') {
        this.loteCabotajeService.cabotageOutputsFilter = [...this.loteCabotajeService.cabotageOutputs];
        return;
      }
      this.loteCabotajeService.cabotageOutputsFilter = this.loteCabotajeService.cabotageOutputs.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListCabotageOutputs.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de pedimentos de importacion y exportacion
    if (currentURL.includes('/petition')) {
      if (this.blTextFilter === '') {
        this.pedimentoAbandonoService.pedimentosFilter = [...this.pedimentoAbandonoService.pedimentos];
        return;
      }
      this.pedimentoAbandonoService.pedimentosFilter = this.pedimentoAbandonoService.pedimentos.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListPedimentos.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de abandonos
    if (currentURL.includes('/abandonment/')) {
      if (this.blTextFilter === '') {
        this.pedimentoAbandonoService.abandonosFilter = [...this.pedimentoAbandonoService.abandonos];
        return;
      }
      this.pedimentoAbandonoService.abandonosFilter = this.pedimentoAbandonoService.abandonos.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListAbandonos.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de boletas de bascula
    if (currentURL.includes('scale-ticket/list')) {
      if (this.blTextFilter === '') {
        this.scaleTicketSvc.scaleTicketsFilter = [...this.scaleTicketSvc.scaleTickets];
        return;
      }
      this.scaleTicketSvc.scaleTicketsFilter = this.scaleTicketSvc.scaleTickets.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (!this.blackListScaleTicket.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Lista de camiones
    if (currentURL.includes('scale-ticket/truck')) {
      if (this.blTextFilter === '') {
        this.scaleTicketSvc.trucksFilter = [...this.scaleTicketSvc.trucks];
        return;
      }
      this.scaleTicketSvc.trucksFilter = this.scaleTicketSvc.trucks.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
            match = true;
          }
        });
        return match;
      });
      return;
    }

    // Lista de catalogos
    if (currentURL.includes('catalogs')) {
      if (this.blTextFilter === '') {
        this.catalogService.listTableFilter = [...this.catalogService.listTable];
        return;
      }
      this.catalogService.listTableFilter = this.catalogService.listTable.filter(item => {
        const values: [string, any][] = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
            match = true;
          }
        });
        return match;
      });
      return;
    }

    // Lista de usuarios
    if (currentURL.includes('users')) {
      if (this.blTextFilter === '') {
        this.authorizationsSvc.userTableFormatFilter = [...this.authorizationsSvc.userTableFormat];
        return;
      }
      this.authorizationsSvc.userTableFormatFilter = this.authorizationsSvc.userTableFormat.filter(item => {
        const values: [string, any][] = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
            match = true;
          }
        });
        return match;
      });
      return;
    }

    // Lista de facturas
    if (currentURL.includes('bill/list')) {
      if (this.blTextFilter === '') {
        this.billingSvc.billsFiltered = [...this.billingSvc.bills];
        return;
      }
      this.billingSvc.billsFiltered = this.billingSvc.bills.filter(item => {
        const values: [string, any][] = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
            match = true;
          }
        });
        return match;
      });
      return;
    }

    // Lista de lotes asignados
    if (currentURL.includes('/ship-list/')) {
      if (this.blTextFilter === '') {
        this.loteService.lotesFilter = [...this.loteService.lotes];
        return;
      }
      this.updateBlackListsByMaterials();
      this.loteService.lotesFilter = this.loteService.lotes.filter(item => {
        const values = Object.entries(item);
        let match = false;
        values.forEach( value => {
          if (
            !this.loteService.loteExport &&
            !this.loteService.loteCabotageImp &&
            !this.loteService.loteCabotageExp &&
            !this.blackListListaLotesAsignados.includes(value[0])
          ) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
          if (!this.blackListListaLotesAsignadosExportCabotage.includes(value[0])) {
            if ((value[1] !== null) && value[1].toString().toLowerCase().includes(this.blTextFilter.toLowerCase())) {
              match = true;
            }
          }
        });
        return match;
      });
      return;
    }

    // Listado de barcos
    if (currentURL.includes('/ship-list')) {
      this.blServices.sortByFilter(false);
      return;
    }
  }

  /**
   * Ajusta las listas negras de campos de lotes asignados según la presencia de materiales específicos (fertilizante y supersacos).
   */
  updateBlackListsByMaterials(): void {
    // 14: Fertilizante and 24: Supersacos
    const materials = [14, 24];
    if (this.loteService.batchListHasTheseMaterials(this.loteService.lotes, materials)) {
      // Quitar 'observations' y agregar 'material_group_name'
      this.blackListListaLotesAsignados = this.blackListListaLotesAsignados.filter(item => item !== 'observations');
      this.blackListListaLotesAsignadosExportCabotage = this.blackListListaLotesAsignadosExportCabotage.filter(item => item !== 'observations');
      if (!this.blackListListaLotesAsignados.includes('material_group_name')) {
        this.blackListListaLotesAsignados.push('material_group_name');
      }
      if (!this.blackListListaLotesAsignadosExportCabotage.includes('material_group_name')) {
        this.blackListListaLotesAsignadosExportCabotage.push('material_group_name');
      }
    } else {
      // Agregar 'observations' y quitar 'material_group_name'
      if (!this.blackListListaLotesAsignados.includes('observations')) {
        this.blackListListaLotesAsignados.push('observations');
      }
      if (!this.blackListListaLotesAsignadosExportCabotage.includes('observations')) {
        this.blackListListaLotesAsignadosExportCabotage.push('observations');
      }
      this.blackListListaLotesAsignados = this.blackListListaLotesAsignados.filter(item => item !== 'material_group_name');
      this.blackListListaLotesAsignadosExportCabotage = this.blackListListaLotesAsignadosExportCabotage.filter(item => item !== 'material_group_name');
    }
  }
}
